// TODO: Urls will eventually come from an AEM source
// This helper component will be deprecated
import {
  Preview1,
  Preview2,
  Preview3,
  Preview4,
  Preview5,
  Preview6,
  Horizontal1,
  Horizontal2,
  Horizontal3,
  Horizontal4,
  Horizontal5,
  Horizontal6,
  Square1,
  Square2,
  Square3,
  Square4,
  Square5,
  Square6,
  Vertical1,
  Vertical2,
  Vertical3,
  Vertical4,
  Vertical5,
  Vertical6,
} from '../../../assets';

export interface ShareableImage {
  altText: string;
  title: string;
  previewUrl: string;
  squareUrl?: string;
  horizontalUrl?: string;
  verticalUrl?: string;
  downloadUrl?: string;
}

export interface ShareableSection {
  images: ShareableImage[];
  moreSizesUrl?: string;
}

const SJMMW_2026_SHAREABLE_EVENT_IDS = [32414, 164588];
const SJMMW_2026_MORE_SIZES_URL =
  'https://www.stjude.org/get-involved/fitness-fundraisers/memphis-marathon/fundraising.html#6232fa856';
export const SJMMW_2026_FUNDRAISING_FAQ_TITLE =
  '2026 SJMMW Dates + Deadlines Fundraising FAQ';
const SJMMW_2026_SHAREABLES_BASE_URL = `${
  process.env.PUBLIC_URL || ''
}/images/shareables/sjmmw`;

const getSjmmw2026AssetUrl = (fileName: string): string =>
  `${SJMMW_2026_SHAREABLES_BASE_URL}/${fileName}`;

const isSjmmw2026ShareablesEvent = (eventId: number): boolean =>
  SJMMW_2026_SHAREABLE_EVENT_IDS.includes(eventId);

const getDefaultShareables = (): ShareableSection => ({
  images: [
    {
      title: 'Astronaut',
      altText:
        'A clay astronaut figure floating in front of a crayon-style drawing of a silver and red rocket ship flying in space around the planet Earth',
      previewUrl: Preview1,
      horizontalUrl: Horizontal1,
      verticalUrl: Vertical1,
      squareUrl: Square1,
    },
    {
      title: 'Heart',
      altText:
        'Crayon-style drawing of a red heart with pink, yellow, and purple waves emanating out from the edges of the heart',
      previewUrl: Preview4,
      horizontalUrl: Horizontal4,
      verticalUrl: Vertical4,
      squareUrl: Square4,
    },
    {
      title: 'Light-fight',
      altText:
        "Yellow text on a red background that reads the following: Unextinguishable. Your light is never as bright as when you're in the fight",
      previewUrl: Preview6,
      horizontalUrl: Horizontal6,
      verticalUrl: Vertical6,
      squareUrl: Square6,
    },

    {
      title: 'LoveStJude',
      altText:
        'White handwriting that says I love St. Jude! on a red background with the same text repeating as a pattern',
      previewUrl: Preview5,
      horizontalUrl: Horizontal5,
      verticalUrl: Vertical5,
      squareUrl: Square5,
    },
    {
      title: 'Rocket',
      altText:
        'Paint/crayon style drawing of a rocket ship which says St. Jude on the side flying through space',
      previewUrl: Preview2,
      horizontalUrl: Horizontal2,
      verticalUrl: Vertical2,
      squareUrl: Square2,
    },
    {
      title: ' Rocket-earth',
      altText:
        'A paint/crayon style drawing of a blue rocket ship with purple wings and green engines flying through space with earth in the background',
      previewUrl: Preview3,
      horizontalUrl: Horizontal3,
      verticalUrl: Vertical3,
      squareUrl: Square3,
    },
  ],
});

const getSjmmw2026Shareables = (): ShareableSection => ({
  images: [
    {
      title: 'Run With Me',
      altText:
        '2026 St. Jude Memphis Marathon Weekend Run With Me shareable image',
      previewUrl: getSjmmw2026AssetUrl('sjmmw-2026-run-with-me.jpg'),
      downloadUrl: getSjmmw2026AssetUrl('sjmmw-2026-run-with-me.jpg'),
    },
    {
      title: 'Join My Team',
      altText:
        '2026 St. Jude Memphis Marathon Weekend Join My Team shareable image',
      previewUrl: getSjmmw2026AssetUrl('sjmmw-2026-join-my-team.jpg'),
      downloadUrl: getSjmmw2026AssetUrl('sjmmw-2026-join-my-team.jpg'),
    },
    {
      title: "I'm a St. Jude Hero",
      altText:
        '2026 St. Jude Memphis Marathon Weekend vertical hero shareable image',
      previewUrl: getSjmmw2026AssetUrl('sjmmw-2026-hero-vertical.jpg'),
      downloadUrl: getSjmmw2026AssetUrl('sjmmw-2026-hero-vertical.jpg'),
    },
    {
      title: "I'm In, Join Me",
      altText:
        '2026 St. Jude Memphis Marathon Weekend I am in, join me shareable image',
      previewUrl: getSjmmw2026AssetUrl('sjmmw-2026-im-in.jpg'),
      downloadUrl: getSjmmw2026AssetUrl('sjmmw-2026-im-in.jpg'),
    },
    {
      title: "I'm a St. Jude Hero Photo",
      altText:
        '2026 St. Jude Memphis Marathon Weekend square hero photo shareable image',
      previewUrl: getSjmmw2026AssetUrl('sjmmw-2026-hero-photo-square.jpg'),
      downloadUrl: getSjmmw2026AssetUrl('sjmmw-2026-hero-photo-square.jpg'),
    },
    {
      title: "I'm a St. Jude Hero",
      altText:
        '2026 St. Jude Memphis Marathon Weekend square hero text shareable image',
      previewUrl: getSjmmw2026AssetUrl('sjmmw-2026-hero-square.jpg'),
      downloadUrl: getSjmmw2026AssetUrl('sjmmw-2026-hero-square.jpg'),
    },
  ],
  moreSizesUrl: SJMMW_2026_MORE_SIZES_URL,
});

export const getSjmmw2026FundraisingFaq = (
  eventId = 0
): { title: string; url: string } | undefined =>
  isSjmmw2026ShareablesEvent(eventId)
    ? {
        title: SJMMW_2026_FUNDRAISING_FAQ_TITLE,
        url: getSjmmw2026AssetUrl('sjmmw-2026-dates-deadlines-faq.docx'),
      }
    : undefined;

export const getShareables = (eventId = 0): ShareableSection =>
  isSjmmw2026ShareablesEvent(eventId)
    ? getSjmmw2026Shareables()
    : getDefaultShareables();
